































































import { Component, Vue } from "vue-property-decorator";
import * as firebase from "firebase/app";

@Component
export default class HeaderTop extends Vue {
  drawerFlg = false;
  salonUrl = "";
  openDrawerMenu() {
    this.drawerFlg = true;
  }
  closeDrawerMenu() {
    this.drawerFlg = false;
  }
  public created() {
    this.salonUrl = process.env.VUE_APP_SALON_ENDPOINT;
  }
}
